var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"modal-class":"santa-image-viewer","hide-footer":"","id":"santa-image-viewer","size":"lg"},on:{"hide":function($event){return _vm.hide()}}},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":_vm.src_url,"alt":_vm.src_url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }